module.exports = __webpack_public_path__ + "img/Photo_6___Construction_992_36_4.7082c729.jpg";